module.exports = __webpack_public_path__ + "static/img/btn2.0eade5a3.png";